import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    saveCollection,
    getAll,
    editData,
    getCollectionProduct,
    updateCollectionCategory
};

async function saveCollection(data){
    let CollectionCategoryMaster = {
        CollectionCategoryMasterID: 0,
        CollectionCategoryCode: data.collectionCategoryCode,
        CollectionCategoryName: data.collectionCategoryName,
        ProductID: parseInt(data.productID),
        
        IsActive: data.isActive,
        CreatedBy: 0,
        CreatedDate: new Date().toISOString(),
        ModifiedBy: 0,
        ModifiedDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/CollectionCategoryMaster/SaveCollectionCategoryMaster', null, CollectionCategoryMaster);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/CollectionCategoryMaster/GetAllCollectionCategoryMaster', null);
    return response.data;
}

async function editData(data) {
    let CollectionCategoryMaster = {
        collectionCategoryMasterID: data.collectionCategoryMasterID,
        collectionCategoryCode: data.collectionCategoryCode,
        collectionCategoryName: data.collectionCategoryName,
        productID: parseInt(data.productID),


        isActive: data.isActive,
        createdBy: data.createdBy,
        createdDate: data.createdDate,
        modifiedBy: data.modifiedBy,
        modifiedDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/CollectionCategoryMaster/UpdateCollectionCategoryMaster', null, CollectionCategoryMaster);
    return response;
}




async function getCollectionProduct() {
    var ProductArray = [];
    const response = await CommonGet('/api/Product/GetProducts', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            ProductArray[item[1]["productID"]] = item[1]["productName"];
        }
    }
    return ProductArray;
}

async function updateCollectionCategory(data) {
    var response = await CommonPost('/api/CollectionCategoryMaster/UpdateCollectionCategoryMaster', null, data);
    return response
}
